(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fde-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fde-faq__question').forEach(button => {
    button.addEventListener('click', () => {
      const item = button.closest('.fde-faq__item');
      const isOpen = item.classList.contains('is-open');
      
      // Close all other items
      document.querySelectorAll('.fde-faq__item').forEach(otherItem => {
        otherItem.classList.remove('is-open');
        otherItem.querySelector('.fde-faq__question').setAttribute('aria-expanded', 'false');
      });
      
      // Toggle current item
      if (!isOpen) {
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
